import { CloudAPI } from 'lib/cloud-sync/cloud-api/types.d'
import { Project } from 'lib/project/types.d'
import {
  assertType,
  serializeAnything,
} from 'lib/cloud-sync/serializer/helpers'
import { CloudSerializer } from 'lib/cloud-sync/serializer/types.d'

const serializeDynamicString = (
  serializer: CloudSerializer.ProjectSerializer,
  object: Project.DynamicString,
): CloudAPI.SyncTreeItem => {
  // check type
  assertType(object, 'dynamicString')

  const syncTreeItem: CloudAPI.SyncTreeItem = {
    _uuid: object.uuid,
    _type: 'dynamicString',
    strings: serializeAnything(serializer, object.strings),
  }
  return syncTreeItem
}

export default serializeDynamicString
